import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Features {
	constructor(el) {
		this.features = el.querySelectorAll('.features__entry')
		this.assets = el.querySelectorAll('.features__asset')

		this.animateText()
		this.animateUiCards()

		window.addEventListener('orientationchange', () => {
			setTimeout(() => ScrollTrigger.refresh(), 500)
		})
	}
	animateText() {
		this.features.forEach((feature) => {
			const content = feature.querySelector('.features__content')
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: feature,
					start: 'top 80%',
					end: 'bottom 20%',
					scrub: 1
				},
			})
			tl.to(content, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				ease: 'power1.out',
				duration: 1
			})
			tl.to(content, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				ease: 'none',
				duration: 0.2
			})
			tl.to(content, {
				scale: 0.9,
				opacity: 0.4,
				filter: 'blur(6px)',
				ease: 'power1.in',
				duration: 1
			})
		})
	}
	animateUiCards() {
		this.assets.forEach(asset => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: asset,
					start: 'top 90%',
					end: 'bottom 10%',
					scrub: 1
				},
			})
			tl.to(asset, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				boxShadow: '0px 149px 42px 0px rgba(0, 0, 0, 0.00), 0px 96px 38px 0px rgba(0, 0, 0, 0.01), 0px 54px 32px 0px rgba(0, 0, 0, 0.03), 0px 24px 24px 0px rgba(0, 0, 0, 0.05), 0px 6px 13px 0px rgba(0, 0, 0, 0.06)',
				ease: 'power1.out',
				duration: 1
			})
			tl.to(asset, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				boxShadow: '0px 149px 42px 0px rgba(0, 0, 0, 0.00), 0px 96px 38px 0px rgba(0, 0, 0, 0.01), 0px 54px 32px 0px rgba(0, 0, 0, 0.03), 0px 24px 24px 0px rgba(0, 0, 0, 0.05), 0px 6px 13px 0px rgba(0, 0, 0, 0.06)',
				ease: 'none',
				duration: 2
			})
			tl.to(asset, {
				scale: 0.9,
				opacity: 0.4,
				filter: 'blur(6px)',
				boxShadow: 'none',
				ease: 'power1.in',
				duration: 1
			})
		})
	}
}

export const initFeatures = () => {
	document.querySelectorAll('.features').forEach(el => {
		new Features(el)
	})
}

export default () => {}